<template>
  <div>
    <head-bottom />
    <div class="ogpo">
      <div class="container">
        <p
          class="ogpo-title"
          v-html="health.title"
        />
        <p
          class="ogpo-sub"
          v-html="health.description"
        />
        <div class="ogpo-cards">
          <div class="ogpo-cards__line" />
          <ul>
            <li
              class="ogpo-cards__par"
              v-html="health.mini_description_first"
            />
            <li
              class="ogpo-cards__par"
              v-html="health.mini_description_second"
            />
            <li
              class="ogpo-cards__par"
              v-html="health.mini_description_third"
            />
          </ul>
        </div>
        <div class="ogpo-btn">
          <button
            id="click8"
            @click="isOpen = true, $refs.myForm.resetForm()"
          >
            {{ health.button }}
          </button>
          <!-- <button @click="isOpen=true">Получить <span>индивидуальную</span> информацию</button> -->
        </div>
        <modal
          :open="isOpen"
          @close="isOpen = !isOpen"
        >
          <get-discount />
          <Form
            ref="myForm"
            @submit="Send"
          >
            <div class="modal-inputs">
              <!-- <input v-model="GuestName" type="text" :placeholder="$t('placeholder.name')" /> -->
              <div class="err-message">
                <Field
                  v-model="GuestName"
                  name="username"
                  type="text"
                  class="name"
                  :placeholder="$t('placeholder.name')"
                  :rules="requiredName"
                  @keyup="onlyText()"
                />
                <div
                  :class="{ remove: IsRemove }"
                  class=""
                >
                  <ErrorMessage name="username" />
                </div>
              </div>
              <div class="err-message">
                <Field
                  v-model="GuestPhone"
                  v-mask="'+7(7##)-###-##-##'"
                  type="text"
                  :placeholder="$t('placeholder.phone')"
                  name="phone"
                  :rules="requiredNum"
                />
                <div
                  :class="{ remove: IsRemove }"
                  class=""
                >
                  <ErrorMessage name="phone" />
                </div>
              </div>
              <div class="err-message">
                <Field
                  v-model="organization_name"
                  type="text"
                  :placeholder="$t('placeholder.company')"
                  name="organization"
                  class="name"
                  :rules="requiredNum"
                />
                <div
                  :class="{ remove: IsRemove }"
                  class=""
                >
                  <ErrorMessage name="organization" />
                </div>
              </div>
              <textarea
                v-model="guest_desc"
                :placeholder="$t('placeholder.com')"
              />
            </div>
            <div class="modal-btn">
              <button
                type="submit"
                :class="{isDisabled : disabled}"
                @click="buttonClicked"
              >
                <div
                  v-if="loading"
                  class="spinner-border spinner-border-sm"
                />
                {{ $t("buttons.send") }}
              </button>
            </div>
            <div class="modal-rule">
              <input
                id="check"
                v-model="checked"
                type="checkbox"
              >
              <label for="check">{{ $t("modal.check1") }}
                <a href="/condition">{{ $t("modal.check2") }}</a></label>
            </div>
          </Form>
        </modal>
      </div>
    </div>
    <div class="middle">
      <hr class="middle-line">
      <div class="container">
        <div class="middle-box">
          <p
            class="middle-box__title"
            v-html="tabs[0].big_title"
          />
          <div class="ogpo-slider">
            <health-slider />
          </div>
          <div class="middle-box__bottom">
            <div class="middle-box__bottom-1">
              <button
                v-for="t in tabs.slice(0, 3)"
                :key="t"
                :value="t"
                @click="tabButton(t)"
                v-html="t.title"
              />
            </div>

            <div class="middle-box__bottom-3">
              <button
                v-for="t in tabs.slice(3, 6)"
                :key="t"
                :value="t"
                @click="tabButton(t)"
                v-html="t.title"
              />
            </div>
            <div
              v-if="tabContent"
              class="middle-box__bottom-2"
            >
              <img
                :src="cdn + tabContent.icon"
                alt=""
              >
              <div
                class="par"
                v-html="tabContent.description"
              />
              <div class="btn">
                <button
                  @click="isOpen = true, $refs.myForm.resetForm()"
                  v-html="tabContent.button"
                />
                <!-- <button @click="isOpen=true">Получить подробную информацию</button> -->
              </div>
            </div>
            <div
              v-else
              class="middle-box__bottom-2"
            >
              <img
                :src="cdn + tabs[0].icon"
                alt=""
              >
              <div
                class="par"
                v-html="tabs[0].description"
              />
              <div class="btn">
                <button
                  id="click8"
                  @click="isOpen = true, $refs.myForm.resetForm()"
                  v-html="tabs[0].button"
                />
                <!-- <button @click="isOpen=true">Получить подробную информацию</button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="about">
      <div class="about-ogpo">
        <p
          class="about-ogpo__title"
          v-html="health3[0].big_title"
        />
        <div
          v-for="(hl, i) in health3"
          :key="hl"
          class="about-ogpo__card"
        >
          <p
            v-if="i < 10"
            class="about-ogpo__card__num"
          >
            0{{ i + 1 }}.
          </p>
          <p
            v-else
            class="about-ogpo__card__num"
          >
            {{ i + 1 }}.
          </p>
          <div class="about-ogpo__card__par">
            <span v-html="hl.title" />
            <p v-html="hl.description" />
          </div>
        </div>
      </div>
    </div>
    <div class="range">
      <range />
    </div>
    <div class="sliderRange">
      <slider-range />
    </div>
    <div class="reverse1">
      <accordion />
      <discount :p_name="p_name" />
    </div>
    <SliderMain1 />
    <client-say />
    <div class="wrap">
      <slider-main-2 />
      <div class="d_none">
        <review-slide />
      </div>
    </div>
  </div>
</template>

<script>
import HeadBottom from "../components/HeadBottom.vue";
import accordion from "../components/accordion.vue";
import Discount from "../components/Discount.vue";
import SliderMain1 from "../components/SliderMain1-1.vue";
import SliderMain2 from "../components/SliderMain2.vue";
import range from "../components/range.vue";
import sliderRange from "../components/sliderRange.vue";
import healthSlider from "../components/box/healthSlider.vue";
import reviewSlide from "../components/box/reviewSlide.vue";
import { ref } from "vue";
import modal from "../components/windows/modal.vue";
import axios from "axios";
import { mapState } from "vuex";
import { Buffer } from "buffer";
import { Field, Form, ErrorMessage } from "vee-validate";
import { useToast } from "vue-toastification";
const toaster = useToast()
// import first from '../assets/images/people.png'
// import second from '../assets/images/clinik.png'
// import third from '../assets/images/special.png'
// import fourth from '../assets/images/gpo4.png'
// import fifth from '../assets/images/medical.png'
// import sixth from '../assets/images/health-img.png'
import getDiscount from "@/components/getDiscount.vue";
import clientSay from "@/components/clientSay.vue";

export default {
  components: {
    HeadBottom,
    accordion,
    Discount,
    SliderMain1,
    SliderMain2,
    modal,
    range,
    sliderRange,
    healthSlider,
    reviewSlide,
    getDiscount,
    clientSay,
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const isOpen = ref(false);
    return { isOpen };
  },
  data() {
    return {
      loading: false,
      disabled: false,
      GuestName: null,
      GuestPhone: null,
      GuestEmail: null,
      product_name: "Медицина",
      p_name: "Медицина",
      tabContent: null,
      resp: [],
      tab: "",
      checked: false,
      organization_name: null,
      guest_desc: null,
      health: [],
      health1: [],
      // health2: [],
      tabs: [],
      IsRemove: false,
    };
  },
  computed: {
    ...mapState(["cdn"]),
  },
  watch: {
    isOpen: function () {
      if (this.isOpen) {
        document.documentElement.style.overflow = "hidden";
        return;
      }
      document.documentElement.style.overflow = "auto";
      this.GuestName = "";
      this.GuestPhone = "";
      this.organization_name = "";
      this.guest_desc = "";
      this.checked = false;
      this.IsRemove = true;
      this.loading = false;
    },
  },
  created() {
    this.getHealth();
  },
  methods: {
    onlyText() {
      this.GuestName = this.GuestName.replace(
        /[^а-яА-ЯёЁәӘіІңҢғҒүҮұҰқҚөӨһҺa-zA-Z\-\s]/gi,
        ""
      );
    },
    buttonClicked() {
      this.disabled = !false;
      setTimeout(() => (this.disabled = !true), 5000);
    },
    requiredName(value) {
      if (!value) {
        return this.$t("placeholder.req");
      }
      return true;
    },
    requiredNum(value) {
      if (!value) {
        return this.$t("placeholder.req");
      }
      return true;
    },
    tabButton(t) {
      if (t == null) {
        this.tabs[0] = t;
      } else {
        this.tabContent = t;
      }
    },
    Send(values, {resetForm}) {
      if (this.checked === true) {
        const auth = new Buffer("Nomad:Qwerty123", "utf-8").toString("base64");
        this.form = {
          username: this.GuestName,
          form_name: "consultant",
          organization_name: this.organization_name,
          phone: this.GuestPhone,
          email: this.GuestEmail,
          description: this.guest_desc,
          product_name: this.product_name,
        };
        axios
          .post("https://bitrix24.cic.kz/api/crm/leads/create/", this.form, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-type": "application/json",
              Authorization: "Basic " + auth,
            },
          })
          .then((res) => {
            if (res.data.status == true) {
              this.loading = !false;
              setTimeout(() => (this.loading = !true), 20000);
              // this.isOpen = false;
              toaster.success(this.$t('notification.success'), {
                  position: "top-right"
                });
              resetForm()
              setTimeout(() => {
                this.isOpen = false;
              }, 500);
            } else {
              toaster.error(this.$t('notification.req'), {
                  position: "top-right"
                });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        toaster.error(
          this.$t('notification.dontagree'), 
          {
            position: "top-right"
          }
        );
      }
    },
    getHealth() {
      axios
        .get("V1/top-products")
        .then((response) => {
          this.health = response.data.data[5].first_block;
          this.tabs = response.data.data[5].second_block;
          this.health3 = response.data.data[5].third_block;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  background: #ffffff;
}
@mixin fontStyle($family, $style, $weight, $size, $lheight, $color) {
  font-family: $family;
  font-style: normal;
  font-weight: $weight;
  font-size: $size;
  line-height: $lheight;
  color: $color;
}
@mixin mobile {
  @media (min-width: 320px) and (max-width: 425px) {
    @content;
  }
}
@mixin tablet {
  @media (min-width: 426px) and (max-width: 768px) {
    @content;
  }
}
@mixin tablet-1024 {
  @media (min-width: 769px) and (max-width: 1023px) {
    @content;
  }
}
@mixin desktop {
  @media (min-width: 1023px) and (max-width: 1440px) {
    @content;
  }
}
@mixin desktop-max {
  @media (min-width: 1620px) and (max-width: 2560px) {
    @content;
  }
}
.wrap {
  @include mobile() {
    padding-top: 15px;
  }
}
.ogpo {
  background: url(../assets/images/health-back.png);
  background-repeat: no-repeat;
  padding-bottom: 120px;
  &-slider {
    display: none;
    @include mobile() {
      display: block;
    }
    @include tablet() {
      display: block;
    }
    @include tablet-1024() {
      display: block;
    }
  }
  &-title {
    @include fontStyle(Roboto, normal, 600, 36px, 49px, #ffffff);
    letter-spacing: 0.015em;
    text-transform: uppercase;
    padding-top: 100px;
    padding-bottom: 30px;
  }
  &-sub {
    @include fontStyle(Roboto, normal, 400, 20px, 25px, #373737);
    letter-spacing: 0.02em;
    // text-transform: uppercase;
    padding-bottom: 73px;
    margin-top: -35px;
  }
  &-cards {
    margin-left: 17px;
    &__line {
      border: 0.8px solid #ffffff;
      transform: rotate(90deg);
      width: 107px;
      height: 0px;
      margin-left: -67px;
      margin-bottom: -40px;
    }
    ul {
      list-style: none;
    }
    ul li::before {
      content: "\2022";
      color: #ffffff;
      font-weight: bold;
      display: inline-block;
      width: 1em;
      margin-left: -18px;
      font-size: 28px;
    }
    &__par {
      @include fontStyle(Roboto, normal, 300, 17px, 5px, #373737);
    }
  }
  &-btn {
    width: 405px;
    height: 70px;
    background: #ffffff;
    border-radius: 15px;
    margin-top: 50px;
    margin-bottom: 120px;
    button {
      width: 405px;
      height: 70px;
      background: #ffffff;
      border-radius: 15px;
      border: none;
      @include fontStyle(Roboto, normal, 500, 18px, 25px, #8948b1);
      &:hover {
        background: linear-gradient(
          90deg,
          #ff4466 0%,
          #be31ce 49.97%,
          #3641ff 100%
        );
        color: #ffffff;
        button {
          -webkit-background-clip: text;
          -webkit-text-fill-color: #ffffff;
          background-clip: text;
        }
      }
    }
  }
  @include mobile() {
    background: url("../images/health-back22.png");
    background-size: cover;
    padding-bottom: 10px;
    background-color: #efefef;
    height: 378px;
    &-title {
      //change
      font-size: 18px;
      line-height: 24px;
      padding: 35px 0 15px 0;
      font-weight: 700;
    }
    &-sub {
      width: 52%;
      font-size: 14px;
      line-height: 15px;
      margin-top: 0;
      padding-bottom: 10px;
      margin-bottom: 0 !important;
    }
    &-btn {
      width: 100%;
      height: 10px;
      margin-top: 16%;
      margin-bottom: 0px;
      button {
        width: 100%;
        height: 45px;
        border-radius: 3px;
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 0px;
        margin: 0 auto;
        span {
          display: none;
        }
      }
    }
    &-cards {
      display: none;
    }
  }
  @include tablet() {
    background: url("../images/health-back22.png");
    background-size: cover;
    padding-bottom: 10px;
    background-color: #efefef;
    height: 378px;
    &-title {
      //change
      font-size: 18px;
      line-height: 24px;
      padding: 35px 0 15px 0;
      font-weight: 700;
    }
    &-sub {
      width: 52%;
      font-size: 14px;
      line-height: 15px;
      margin-top: 0;
      padding-bottom: 10px;
      margin-bottom: 0 !important;
    }
    &-btn {
      width: 100%;
      height: 10px;
      margin-top: 16%;
      margin-bottom: 0px;
      button {
        width: 100%;
        height: 45px;
        border-radius: 3px;
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 0px;
        margin: 0 auto;
        span {
          display: none;
        }
      }
    }
    &-cards {
      display: none;
    }
  }
  @include tablet-1024() {
    background-size: cover;
    padding-bottom: 10px;
    &-title {
      font-size: 24px;
      line-height: 29px;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    &-sub {
      padding-bottom: 80px;
      padding-top: 30px;
      font-size: 12px;
      line-height: 15px;
      margin-bottom: 0;
    }
    &-cards {
      &__box {
        width: 120px;
        height: 60px;
        padding: 24px 0 65px 20px;
        font-size: 10px;
        line-height: 14px;
      }
    }
    &-btn {
      width: 200px;
      height: 50px;
      border-radius: 8px;
      margin-top: 50px;
      button {
        width: 200px;
        height: 50px;
        border-radius: 8px;
        font-size: 9px;
        line-height: 14px;
      }
    }
  }
  @include desktop() {
    &-cards {
      ul {
        li::before {
          font-size: 24px;
        }
      }
    }
  }
}
.middle-box__bottom-1 .button:hover + .middle-box__bottom-3 .par {
  font-size: 50px;
}
.middle {
  &-line {
    background: linear-gradient(
      90deg,
      #ff143f 0%,
      #c600dd 49.97%,
      #1b27ff 100%
    );
    height: 1px;
    // margin-top: -170px;
    position: relative;
    z-index: 3;
  }
  &-box {
    z-index: 2;
    background-color: #f6f6f6;
    padding: 100px 100px;
    border-radius: 15px;
    margin-top: -200px;
    max-width: 1320px;
    width: 100%;
    &__title {
      @include fontStyle(Roboto, normal, 500, 28px, 38px, #373737);
      text-align: center;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      text-align: center;
      margin-bottom: 60px;
    }
    &__bottom {
      display: flex;
      justify-content: space-between;
      &-1 {
        width: 250px;
        height: 80px;
        text-align: center;
      }
      &-1,
      &-3 {
        max-width: 300px;
        flex-wrap: wrap;
        button {
          background-color: #f6f6f6;
          width: 190px;
          height: 60px;
          border: 1px solid #c4c4c4;
          border-radius: 15px;
          @include fontStyle(Roboto, normal, 300, 15px, 25px, #373737);
          margin-top: 40px;
          &:hover {
            filter: drop-shadow(0px 4px 43px rgba(0, 0, 0, 0.15));
            background-color: #fff;
            border: none;
            .middle-box__bottom-2 .par {
              background: linear-gradient(
                90deg,
                #ff143f 0%,
                #c600dd 49.97%,
                #1b27ff 100%
              );
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
            }
          }
        }
      }
      &-2 {
        text-align: center;
        height: 380px;
        img {
          max-width: 106px;
          max-height: 106px;
        }
        .par {
          @include fontStyle(Roboto, normal, 300, 18px, 25px, #373737);
          padding-top: 20px;
          padding-bottom: 60px;
          text-align: center;
          margin: 0 auto;
          height: 180px;
          width: 330px;
        }
        .btn {
          width: 380px;
          height: 70px;
          background: #ffffff;
          border-radius: 15px;
          button {
            padding-top: 15px;
            background: #ffffff;
            border: none;
            @include fontStyle(Roboto, normal, 500, 18px, 25px, #8948b1);
          }
          &:hover {
            background: linear-gradient(
              90deg,
              #ff4466 0%,
              #be31ce 49.97%,
              #3641ff 100%
            );
            color: #ffffff;
            button {
              -webkit-background-clip: text;
              -webkit-text-fill-color: #ffffff;
              background-clip: text;
            }
          }
        }
      }
      &-3 {
        text-align: center;
      }
    }
  }
  @include mobile() {
    padding-top: 15px;
    padding-bottom: 25px;
    background: #efefef;
    background-size: cover;
    &-line {
      display: none;
    }
    &-box {
      margin-top: 0;
      background: transparent;
      padding: 0;
      &__title {
        font-size: 14px;
        line-height: 16px;
        text-align: left;
        letter-spacing: 0;
        margin-bottom: 10px;
        padding-top: 30px;
      }
      &__bottom {
        display: none;
      }
    }
  }
  @include tablet() {
    background: #efefef;
    background-size: cover;
    &-line {
      display: none;
    }
    &-box {
      margin-top: 0;
      background: transparent;
      padding: 0;
      &__title {
        font-size: 12px;
        line-height: 14px;
        text-align: left;
        letter-spacing: 0;
        margin-bottom: 10px;
        padding-top: 30px;
      }
      &__bottom {
        display: none;
      }
    }
  }
  @include tablet-1024() {
    background: #f6f6f6;
    &-line {
      display: none;
    }
    &-box {
      margin-top: 0px;
      padding: 50px 70px;
      background: #f6f6f6;
      &__title {
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 30px;
      }
      &__bottom {
        display: none;
      }
    }
  }
  @include desktop() {
    &-line {
      margin-top: 0px;
      height: 1px;
    }
    &-box {
      margin-top: -160px;
      padding: 50px;
      &__title {
        font-size: 22px;
        line-height: 26px;
      }
      &__bottom {
        &-2 {
          width: 100%;
          padding-left: 10px;
          .btn {
            width: 280px;
            height: 60px;
            border-radius: 10px;
            button {
              font-size: 14px;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}
.about {
  margin: 0 auto;
  max-width: 1320px;
  width: 80%;
  &-ogpo {
    margin-top: 95px;
    &__title {
      @include fontStyle(Roboto, normal, 500, 36px, 43px, #373737);
      letter-spacing: 0.03em;
      text-transform: uppercase;
      text-align: center;
      padding-bottom: 10px;
    }
    &__card {
      display: flex;
      align-items: center;
      &__num {
        @include fontStyle(Roboto, normal, 900, 60px, 82px, transparent);
        background: -webkit-linear-gradient(
          90deg,
          #ff143f 0%,
          #c600dd 49.97%,
          #1b27ff 100%
        );
        -webkit-background-clip: text;
        -webkit-text-stroke: 2px transparent;
        color: #ffffff;
        align-items: center;
      }
      &__par {
        @include fontStyle(Roboto, normal, 300, 16px, 22px, #373737);
        background: #f6f6f6;
        border: 1px solid rgba(255, 255, 255, 0.05);
        box-sizing: border-box;
        backdrop-filter: blur(55px);
        border-radius: 15px;
        padding: 20px;
        margin-left: 12px;
        width: 1220px;
        display: flex;
        align-items: baseline;
        height: 80px;
        span {
          @include fontStyle(Roboto, normal, 400, 24px, 29px, #373737);
          padding-right: 20px;
        }
      }
    }
  }
  @include mobile() {
    width: 90%;
    &-ogpo {
      margin-top: 35px;
      margin-bottom: 3px;
      &__title {
        //change
        font-size: 14px;
        font-weight: 600;
        line-height: 14px;
        background: linear-gradient(
          90deg,
          #ff143f 0%,
          #c600dd 49.97%,
          #1b27ff 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-align: left;
        margin-bottom: 0;
      }
      &__card {
        align-items: baseline;
        margin-bottom: 13px;
        &__num {
          //change
          font-size: 14px;
          line-height: 15px;
          font-weight: 700;
          letter-spacing: 0.03em;
          padding: 1px;
        }
        &__par {
          display: flex;
          flex-wrap: wrap;
          //change
          font-size: 14px;
          line-height: 16px;
          font-weight: 400;
          background: transparent;
          margin-left: 5px;
          padding: 0;
          height: 50px;
          margin-bottom: 15px;
          span {
            width: 100%;
            //change
            font-size: 14px;
            line-height: 16px;
            font-weight: 500;
            padding-right: 10px;
          }
        }
      }
    }
  }
  @include tablet() {
    padding-top: 20px;
    padding-bottom: 20px;
    &-ogpo {
      margin-top: 25px;
      &__title {
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
        background: linear-gradient(
          90deg,
          #ff143f 0%,
          #c600dd 49.97%,
          #1b27ff 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-align: left;
      }
      &__card {
        align-items: baseline;
        &__num {
          font-size: 14px;
          line-height: 18px;
          font-weight: 700;
          letter-spacing: 0.03em;
        }
        &__par {
          display: flex;
          flex-wrap: wrap;
          font-size: 14px;
          line-height: 18px;
          font-weight: 400;
          background: transparent;
          margin-left: 5px;
          padding: 0;
          span {
            font-size: 14px;
            line-height: 18px;
            width: 100%;
            font-weight: 500;
            padding-right: 10px;
          }
        }
      }
    }
  }
  @include tablet-1024() {
    &-ogpo {
      &__title {
        font-size: 30px;
        line-height: 33px;
      }
      &__card {
        margin-bottom: 15px;
        &__num {
          font-size: 35px;
          line-height: 42px;
        }
        &__par {
          font-size: 16px;
          line-height: 20px;
          height: 90px;
          span {
            font-size: 20px;
            line-height: 25px;
          }
        }
      }
    }
  }
}
</style>
